import * as yup from 'yup'

import { 
    trimmedInputValues,
} from '../utils';

const DispatchTrackingDetailsValidation = yup.object().shape({
    logisticPartnerId: yup.number().required("Please select logistic partner"),
    trackingNumber: yup.string()
        .required('Please enter tracking number')
        .transform((value) => trimmedInputValues(value)),
    trackingOrderLink: yup.string()
        .required('Please enter tracking order link')
        .transform((value) => trimmedInputValues(value)),
    expectedDeliveryDate: yup.string()
        .required('Please select delivery date')
});

const initialTrackingDetails = {
    logisticPartnerId: null,
    trackingNumber: null,
    trackingOrderLink: "",
    trackingDocument: null, 
    expectedDeliveryDate: new Date(new Date()),
}


export { DispatchTrackingDetailsValidation, initialTrackingDetails }